import React from "react";
import GlobalMetricCards from "../../../../../global/GlobalMetricCards";

export default function MaintenanceDashboardMetricsSection({ metrics, loadingMetrics }) {
  const items = metrics
    ? [
        {
          key: "total-requests",
          value: metrics.total_requests ?? 0,
          label: "Total requests",
          tone: "teal",
          chartHeights: [0.38, 0.62, 0.45, 0.78, 0.52],
        },
        {
          key: "pending-requests",
          value: metrics.pending_requests ?? 0,
          label: "Pending",
          tone: "coral",
          chartHeights: [0.25, 0.45, 0.35, 0.65, 0.42],
        },
        {
          key: "in-progress-requests",
          value: metrics.in_progress_requests ?? 0,
          label: "In progress",
          tone: "mint",
          chartHeights: [0.55, 0.38, 0.72, 0.48, 0.58],
        },
        {
          key: "completed-requests",
          value: metrics.completed_requests ?? 0,
          label: "Completed",
          tone: "slate",
          chartHeights: [0.82, 0.68, 0.75, 0.92, 0.88],
        },
        {
          key: "total-cost",
          value:
            metrics.total_cost != null
              ? `₹${Number(metrics.total_cost).toFixed(2)}`
              : "₹0.00",
          label: "Total cost",
          tone: "teal",
          chartHeights: [0.42, 0.58, 0.38, 0.75, 0.62],
        },
      ]
    : [];

  return (
    <div
      id="md-stats"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Performance overview</h3>
        <p className="user-builder-panel__hint">
          Live maintenance statistics and cost tracking.
        </p>
      </div>
      <GlobalMetricCards
        items={items}
        loading={loadingMetrics}
        skeletonCount={5}
        ariaLabel="Maintenance dashboard statistics"
      />
    </div>
  );
}
